/**
 * @description General Dropdown
 */

/* global polyfillsIE */

(() => {
	// FUNCTION
	const dropdown = () => {
		document
			.querySelectorAll('[data-js-dropdown-toggle]')
			.forEach((element) => {
				element.addEventListener('click', () => {
					element.classList.toggle('active');
					element.nextElementSibling.classList.toggle('active');
				});
			});
	};

	// GO après chargement 🚀
	window.addEventListener('load', () => {
		polyfillsIE();
		dropdown();
	});
})();
